export const environment = {
  production: true,
  // backendUrl: 'http://localhost:3004'
  // backendUrl: 'https://backendserver.grupoinova.es:3004'
  backendUrl: 'https://colegiados.cafsevilla.com/api'

};
